/*
 *
 * Workspace Project Constants
 *
 */

export const SET_PROJECT_LIST = 'app/Workspace/Project/SET_PROJECT_LIST';
export const SET_SELECTED_PROJECT = 'app/Workspace/Project/SET_SELECTED_PROJECT';

export const GET_INGESTION_LIST = 'app/Workspace/Project/GET_INGESTION_LIST';
export const GET_INGESTION_RECORD = 'app/Workspace/Project/GET_INGESTION_RECORD';
export const DELETE_INGESTION_RECORD = 'app/Workspace/Project/DELETE_INGESTION_RECORD';

export const SET_ACTIVITY_LIVE_LIST = '/app/Workspace/Project/ACTIVITY_LIVE_LIST';
export const SET_ELEMENT_PUBLISHED_LIST = '/app/Workspace/Project/ELEMENT_PUBLISHED_LIST';
export const SET_MARKET_DERIVATIVE_LIST = '/app/Workspace/Project/MARKET_DERIVATIVE_LIST';
export const SET_LANGUAGE_LIST = '/app/Workspace/Project/LANGUAGE_LIST';
export const SET_SELECTED_LANGUAGE = '/app/Workspace/Project/SET_SELECTED_LANGUAGE';